
import { dumbledoreMediaArray } from './dumbledoreMedia'
import { hermioneReviewerProfile, ronReviewerProfile, harryReviewerProfile } from './dumbledoreReviewers'
import { ronBio, hermioneBio, dumbledoreBio, harryBio } from './dumbledoreBios'
import { dumbledoreDatingProfileHinge, dumbledoreDatingProfileBumble, dumbledoreDatingProfileTinder } from './dumbledoreDatingProfiles'

export const dumbledoreUser = {
  _id: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...hermioneReviewerProfile },
    { ...ronReviewerProfile },
    { ...harryReviewerProfile }
  ],
  media: [ ...dumbledoreMediaArray ],
  bio: { ...dumbledoreBio },
  datingProfiles: [
    { ...dumbledoreDatingProfileHinge },
    { ...dumbledoreDatingProfileBumble },
    { ...dumbledoreDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const hermioneUser = {
  _id: 'hermioneUserId',
  email: 'hermione@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...hermioneBio },
  datingProfiles: [],
  reviewerProfile: { ...hermioneReviewerProfile },
}

export const ronUser = {
  _id: 'ronUserId',
  email: 'ron@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...ronBio },
  datingProfiles: [],
  reviewerProfile: { ...ronReviewerProfile },
}

export const harryUser = {
  _id: 'harryUserId',
  email: 'harry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...harryBio },
  datingProfiles: [],
  reviewerProfile: { ...harryReviewerProfile },
}
